import React from 'react'

function TechSelectgdr() {
  return (
    <embed src="\pdfs\E2.1.2_gd-r_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectgdr